import { request } from '../axios/request';
import * as queryParams from 'qs';
import {
  FETCH_PRODUCT_LIST_PENDING,
  FETCH_PRODUCT_LIST_REJECTED,
  FETCH_PRODUCT_LIST_FULFILLED,
} from '../constants/productList';
import { urlParser } from 'theme/utils';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

// utils
let pagination = [{ page: 1 }],
  currentSort = [],
  url = '',
  currentFilters = [];

const buildQueryParams = (paramsArray) => {
  let queryString = '';
  paramsArray.forEach((params) => {
    params.forEach((param) => {
      queryString =
        queryString !== ''
          ? `${queryString}&${queryParams.stringify(param)}`
          : queryParams.stringify(param);
    });
  });

  return queryString;
};

const getQueryString = () =>
  buildQueryParams([pagination, currentFilters, currentSort]);

const pending = () => ({
  type: FETCH_PRODUCT_LIST_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_PRODUCT_LIST_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_PRODUCT_LIST_REJECTED,
  error: error,
});

export const fetchProducts =
  (params = '') =>
  (dispatch) => {
    dispatch(pending());

    request({ method: 'get', url: `/${url}/?${params}` })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const setSorter = (param) => {
  currentSort = [];
  currentSort.push({ sorter: param });

  return fetchProducts(getQueryString());
};

export const setFilter = (facets, search_text) => {
  currentFilters = [];
  const facetsKeys = Object.keys(facets);

  facetsKeys.forEach((key) => {
    facets[key].data.choices.forEach((choice) => {
      if (choice.is_selected) {
        const param = {};
        param[facets[key].search_key] = choice.value;
        currentFilters.push(param);
      }
    });
  });
  if (search_text != null) {
    currentFilters.push({ search_text: search_text });
  }
  pagination.page = Number(localStorage.getItem('savedCurrentPage')) || 1;

  return fetchProducts(getQueryString());
};

export const emptyFilters = () => {
  Object.keys(currentFilters).forEach((el) => {
    if (el !== 'category_ids') {
      delete currentFilters[el];
    }
  });
  return fetchProducts(getQueryString());
};

export const removeFilter = (search_key, value) => {
  currentFilters.forEach((filter) => {
    if (filter[search_key] === value) {
      delete filter[search_key];
    }
  });

  return fetchProducts(getQueryString());
};

export const setPage = (page) => {
  pagination[0].page = page;
  return fetchProducts(getQueryString());
};

export const getInitialProducts = (initialParam) => {
  let _initialParam = urlParser(
    initialParam.url ? initialParam.url : $U.PRODUCT_LIST
  );

  url = _initialParam.base.length ? _initialParam.base : $U.PRODUCT_LIST;
  currentFilters = _initialParam.filters;
  currentFilters.push({ format: 'json' });
  currentSort = _initialParam.sorters;

  const localPathName = JSON.parse(localStorage.getItem('currentPathname'));
  let sameUrl = localPathName === window.location.pathname.toString();

  if (!sameUrl) {
    localStorage.setItem('savedCurrentPage', 1);
  }

  let localSavedPage = !isNaN(Number(localStorage.getItem('savedCurrentPage')))
    ? Number(localStorage.getItem('savedCurrentPage'))
    : 1;

  pagination = [{ page: sameUrl ? localSavedPage : 1 }];

  if (Array.isArray(initialParam.filters)) {
    initialParam.filters.forEach((filter) => {
      currentFilters.push(filter);
    });
  }

  return fetchProducts(getQueryString());
};



// WEBPACK FOOTER //
// ./src/actions/productList.js